/**
 * Zweck: Erfragt die rechtliche Entscheidung zum Import-Hinweis für größere DE-Mengen.
 */
import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Artikel} from '../../../../models/artikel';
import {ImportHinweisOption, ImportHinweisResult} from '../../../../models/import-hinweis';

/**
 * Zweck: Stellt den Dialog für die AWEG-Entscheidung eines Import-Artikels bereit.
 */
@Component({
  templateUrl: 'shop.dialogs.import-hinweis.component.html',
  styleUrls: ['shop.dialogs.import-hinweis.component.scss'],
  standalone: false
})
export class ShopDialogsImportHinweisComponent {
  selectedOption: ImportHinweisOption = null;

  /**
   * Beschreibt Methode constructor und ihren Rückgabevertrag.
   */
  constructor(public dialogRef: MatDialogRef<ShopDialogsImportHinweisComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { artikel: Artikel }) {
  }

  /**
   * Beschreibt Methode confirm und ihren Rückgabevertrag.
   */
  confirm(): void {
    if (this.selectedOption) {
      const result: ImportHinweisResult = {
        decision: 'confirm',
        option: this.selectedOption
      };
      this.dialogRef.close(result);
    }
  }

  /**
   * Beschreibt Methode reduce und ihren Rückgabevertrag.
   */
  reduce(): void {
    this.dialogRef.close({decision: 'reduce'} as ImportHinweisResult);
  }
}
